import { Controller } from 'stimulus'

export default class PricingController extends Controller {
  static targets = ['licenseBuyLink']

  selectedCurrency = null

  availableCurrencies = []

  setCurrency(e) {
    const { currency, availableCurrencies } = e.detail

    this.selectedCurrency = currency
    this.availableCurrencies = availableCurrencies

    const links = this.licenseBuyLinkTargets || []
    links.forEach((target) => {
      target.classList.remove('is-disabled')

      const newHref = new URL('/store/', window.location.origin)
      newHref.searchParams.set('currency', this.selectedCurrency)

      target.href = newHref.toString()
    })
  }
}
